var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 108.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.46,34.47c0-13.52,10.41-22.75,23.69-22.75,3.8,0,9.29.75,13.34,2.56v9.91c-3.24-1.99-8.04-2.99-11.91-2.99-8.98,0-15.02,5.39-15.02,13.4s5.73,13.21,14.59,13.21c1.68,0,3.46-.19,5.11-.66v-7.82h-7.36v-8.41h17.02v22.56c-3.62,2.18-10.53,3.8-16.08,3.8-13.53,0-23.38-9.6-23.38-22.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.93,12.59h9.85v34.35h18.89v9.29h-28.74V12.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.36,12.59h28.8v8.85h-19.07v8.04h16.14v9.1h-16.14v8.66h19.95v8.98h-29.67V12.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.77,12.59h9.54l18.45,27.49V12.59h9.47v43.63h-9.47l-18.51-27.61v27.61h-9.47V12.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.76,12.59h14.71c12.59,0,22.81,8.48,22.81,21.88s-10.22,21.76-22.81,21.76h-14.71V12.59ZM202.47,47.09c7.17,0,12.84-4.24,12.84-12.62s-5.67-12.44-12.84-12.44h-4.86v25.06h4.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.81,12.59h11.97l16.21,43.63h-10.66l-3.02-8.73h-17.14l-3.02,8.73h-10.53l16.21-43.63ZM257.81,38.96l-6.05-16.36-6.08,16.36h12.12Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.45,12.59h9.85v34.35h18.89v9.29h-28.74V12.59Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.87,12.59h28.8v8.85h-19.07v8.04h16.14v9.1h-16.14v8.66h19.95v8.98h-29.67V12.59Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.74,75.65h5.57l7.54,20.31h-4.96l-1.41-4.06h-7.98l-1.41,4.06h-4.9l7.54-20.31ZM110.33,87.92l-2.81-7.61-2.83,7.61h5.64Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.32,75.65h4.44l8.59,12.79v-12.79h4.41v20.31h-4.41l-8.62-12.85v12.85h-4.41v-20.31Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.76,75.65h5.57l7.54,20.31h-4.96l-1.41-4.06h-7.98l-1.41,4.06h-4.9l7.54-20.31ZM155.35,87.92l-2.81-7.61-2.83,7.61h5.64Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.34,75.65h4.58v15.98h8.79v4.32h-13.37v-20.31Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.38,87.83l-7.89-12.18h5.68l4.5,7.54,4.5-7.54h5.68l-7.89,12.18v8.12h-4.58v-8.12Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.1,79.94h-5.45v-4.29h15.49v4.29h-5.45v16.01h-4.58v-16.01Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.19,75.65h4.61v20.31h-4.61v-20.31Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.07,85.89c0-5.77,4.38-10.64,10.73-10.64,1.94,0,4.32.45,5.69,1.29v4.67c-1.16-1-3.13-1.61-5.13-1.61-4.23,0-6.47,2.7-6.47,6.09s2.35,6.32,6.64,6.32c1.75,0,3.6-.49,4.96-1.29v4.58c-1.32.74-3.77,1.14-5.66,1.14-6.41,0-10.76-4.81-10.76-10.56Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.42,94.83v-4.83c1.61,1.04,3.49,1.89,6,1.89,1.54,0,3.68-.47,3.68-1.8,0-2.87-9.89-1.51-9.89-8.3,0-3.77,3.05-6.5,7.66-6.5,1.86,0,4.09.45,5.63,1.19v4.66c-1.44-.88-3.42-1.55-5.13-1.55-2.15,0-3.6.78-3.6,1.86,0,2.84,10.09,1.39,10.09,8.27,0,3.8-3.07,6.58-7.71,6.58-3.25,0-5.25-.75-6.73-1.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmarkWhite);
export default __webpack_public_path__ + "static/media/wordmark-white.f8e71465055961678a1cdb8c1169a45f.svg";
export { ForwardRef as ReactComponent };